import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';

@Injectable()
export class EnvironmentActions implements IEnvironmentActions {

  static UPDATE = '[Environment] UPDATE';
  static ADD = '[Environment] ADD';

  public Add(environment: string): any {
    return {
      type:  EnvironmentActions.ADD,
      payload: environment
    };
  }

}
